import { PlusCircle } from "react-feather";
import DataTable from "../Generic/DataTable";
import React, { useContext, useEffect, useRef, useState } from "react";
import { tenantContext } from "../Main/contexts";
import { GetMembership, MailboxMembers, UpdateMembership } from "./TenantAPI";
import Loading from "../Generic/loading";
import { dataColumn } from "../Generic/DataTable";
import { sortByField, SortEnquiriesParams } from "../Logic/sort";
import TextBox from "../Generic/TextBox";
import NumberBox from "../Generic/NumberBox";
import ToggleSwitch from "../Generic/ToggleSwitch";
import TextArea from "../Generic/TextArea";
import Dropdown from "../Generic/DropDown";
import { Departments, GetDepartmentResponse, GetDepartments } from "../Logic/department";
import { GetMailboxRoles, MailboxRolesListItemDTO } from "../Roles/TenantAPI";
import { GetMailboxes, MailboxList } from "../Mailboxes/TenantAPI";
import { GetUsers, UsersGridListDTO, UsersListDTO } from "../Users/TenantAPI";

function Memberships() {
    const { selectedTenant } = useContext(tenantContext);
    const [isLoading, setIsLoading] = useState<Boolean>(true);
    const [allUsers, setAllUsers] = useState<Array<UsersGridListDTO>>([]);
    const [filteredUsers, setFiltertedUsers] = useState<Array<UsersGridListDTO>>([]);
    const [sortBy, setSortBy] = useState<SortEnquiriesParams>();
    const [selectedItem, setSelectedItem] = useState("");
    const [mailboxes, setMailboxes] = useState<Array<MailboxList>>([]);
    const [mailboxesFiltered, setmailboxesFiltered] = useState<Array<MailboxList>>([]);
    const [mailboxRoles, setMailboxroles] = useState<Array<MailboxRolesListItemDTO>>([]);
    const [isNewUser, setIsNewUser] = useState<Boolean>(true);
    const [validationErrors, setValidationErrors] = useState<Array<string>>([]);
    const [selectedMailboxMembership, setSelectedMailboxMembership] = useState<MailboxMembers | undefined>(undefined);
    const mailboxFilterT = useRef<HTMLInputElement>(null);
    const mailboxCheckboxFilterT = useRef(null);

    useEffect(() => {
        (async () => {
            if (selectedTenant) {
                const user_results = GetUsers(selectedTenant.token);
                const mailboxes_results = GetMailboxes(selectedTenant.token);
                const mailboxRoles_results = GetMailboxRoles(selectedTenant.token);
                Promise.all([user_results, mailboxes_results, mailboxRoles_results]).then(results => {
                    if (results[0].isOk) {
                        let filtertedList = results[0]
                            .data!.users!.slice()
                            .sort((a, b) => (a.firstname ?? "").localeCompare(b.firstname ?? ""))
                            .map(user => {
                                return {
                                    id: user.id,
                                    userName: user.firstname + " " + user.lastname,
                                    blocked: user.blocked,
                                    globalRole: user.globalRole,
                                    department: user.department,
                                };
                            });
                        setAllUsers(filtertedList);
                        setFiltertedUsers(filtertedList);
                    }
                    if (results[1].isOk) {
                        setMailboxes(results[1].data?.items!);
                        setmailboxesFiltered(results[1].data?.items!);
                    }
                    if (results[2].isOk) {
                        setMailboxroles(results[2].data?.items!);
                    }
                    setIsLoading(false);
                });
            }
        })();
    }, [selectedTenant]);

    let AllColumns: dataColumn<MailboxList>[] = [
        {
            title: <>Mailbox</>,
            toolTip: "name",
            key: "name",
            getData: (data: MailboxList) => {
                return <>{data.name}</>;
            },
            width: "100%",
            canResize: false,
            sort: {
                direction: undefined,
                sortMethod: () => {
                    handleHeaderClick("name");
                },
                displayIcon: false,
            },
            textAlignment: "left",
            minWidth: "60px",
        },
    ];

    const handleHeaderClick = (fieldName: string): any => {
        let sortO = sortBy;
        if (!sortO) {
            sortO = {
                orderBy: fieldName,
                desc: false,
            };
        } else {
            sortO.orderBy = fieldName;
            sortO.desc = sortO.desc ? false : true;
        }
        let updatedGrids = sortByField(mailboxesFiltered, fieldName, sortO.desc);
        setmailboxesFiltered(updatedGrids);
        setSortBy(sortO);
    };

    function OnFilter(filterValue: string) {
        let filtertedList = mailboxes;
        let filtered = filtertedList.filter(x => x.name.toLowerCase().includes(filterValue.toLowerCase()));
        setmailboxesFiltered(filtered);
    }

    function MailBoxOnFilter(filterValue: string) {
        let filtertedList = allUsers;
        let filtered = filtertedList.filter(x => x.userName.toLowerCase().includes(filterValue.toLowerCase()));
        setFiltertedUsers(filtered);
    }

    const filteredCheckbox = (checked: boolean) => {
        let filtered = allUsers.filter(x =>
            x.userName.toLowerCase().includes(mailboxFilterT.current!.value.toLowerCase()),
        );
        if (checked) {
            filtered = filtered.filter(
                x => x.id == selectedMailboxMembership?.members.find(c => c.userID == x.id)?.userID,
            );
            setFiltertedUsers(filtered);
        } else {
            setFiltertedUsers(filtered);
        }
    };

    async function getMailboxMembershipInfo(id: string) {
        if (selectedTenant) {
            setSelectedItem(id);
            const result = await GetMembership(selectedTenant.token, parseInt(id));
            if (result.isOk && result.data) {
                setSelectedMailboxMembership({
                    mailboxID: parseInt(id),
                    members: result.data.items.filter(x => x.userID == allUsers.find(c => c.id == x.userID)?.id),
                });
                setIsNewUser(false);
            }
        }
    }
    const isUserBlocked = (item: UsersGridListDTO): string => {
        return item.blocked ? " blocked " : "active ";
    };
    const updateValue = (field: string, value: any) => {
        if (value == "undefined" || value == "null") return;
        let uUser: MailboxMembers = JSON.parse(JSON.stringify(selectedMailboxMembership));

        if (uUser.members.find(x => x.userID.toString() == field)) {
            if (value == "0") {
                // Means no access
                uUser.members = uUser.members.filter(x => x.userID.toString() != field);
            } else {
                uUser.members.find(x => x.userID.toString() == field)!.roleID = value;
            }
        } else {
            if (value !== "0") {
                uUser.members.push({ userID: parseInt(field), roleID: value });
            }
        }
        setSelectedMailboxMembership(uUser);
    };

    const updateUserMembership = async () => {
        if (isValidMailboxMembership()) {
            if (selectedTenant && selectedMailboxMembership) {
                const result = await UpdateMembership(
                    selectedTenant.token,
                    selectedMailboxMembership.mailboxID,
                    selectedMailboxMembership,
                );
                if (result.isOk) {
                    alert("user Updated");
                }
            }
        }
    };

    const isValidMailboxMembership = (): boolean => {
        if (
            selectedMailboxMembership &&
            selectedMailboxMembership.members.find(x => x.roleID == undefined || x.roleID == null)
        ) {
            alert("Please select a value for the highlighted field");
            return false;
        }
        return true;
    };

    return (
        <>
            <div className="topSection">
                <div className="sectionHeader"> Mailbox - Memberships</div>
                {selectedMailboxMembership && !isNewUser && (
                    <div>
                        <button
                            className="g-btn-large btn-primary"
                            onClick={updateUserMembership}
                        >
                            {" "}
                            Update Membership{" "}
                        </button>
                    </div>
                )}
            </div>
            <div style={{ display: "flex", flexDirection: "row", height: "calc(100% - 44px)" }}>
                <div className="Users-bodyCol1">
                    {isLoading && <Loading></Loading>}
                    {!isLoading && (
                        <>
                            <div className="filterContainer">
                                <div>Filter: </div>
                                <div>
                                    <input
                                        type="text"
                                        style={{ width: "100%" }}
                                        onChange={e => OnFilter(e.currentTarget.value)}
                                        defaultValue={""}
                                    />
                                </div>
                            </div>
                            <DataTable
                                data={mailboxesFiltered
                                    .slice()
                                    .sort((a, b) => (a.name ?? "").localeCompare(b.name ?? ""))}
                                columns={AllColumns}
                                onRowClick={(val: string) => {
                                    getMailboxMembershipInfo(val);
                                }}
                                onRowDblClick={() => {}}
                                selectedItem={selectedItem}
                                uniqueIdentifiyer={x => {
                                    return x.id.toString();
                                }}
                            ></DataTable>
                        </>
                    )}
                </div>
                {selectedMailboxMembership && (
                    <div className="bodyCol2">
                        <div className="optionsRow">
                            <p style={{ marginBottom: "6px", marginTop: "-0px", fontWeight: "bold", fontSize: "12pt" }}>
                                User Memberships{" "}
                            </p>
                        </div>
                        <div className="filterMailboxContainer">
                            <div>Filter: </div>
                            <div>
                                <input
                                    type="text"
                                    style={{ width: "100%" }}
                                    onChange={e => MailBoxOnFilter(e.currentTarget.value)}
                                    ref={mailboxFilterT}
                                    key={"BoxMailIdds"}
                                />
                            </div>
                        </div>
                        <div className="filterMailboxContainer">
                            <div>Filter by Access: </div>
                            <div>
                                <input
                                    type="checkbox"
                                    onChange={e => filteredCheckbox(e.currentTarget.checked)}
                                    value={""}
                                    ref={mailboxCheckboxFilterT}
                                />
                            </div>
                        </div>
                        {filteredUsers
                            .filter(x => x.blocked === false)
                            .map((c, i) => {
                                const membershipM = selectedMailboxMembership.members.find(x => x.userID == c.id);
                                let options: [{ label: string; value: string }] = [{ label: " No Access", value: "0" }];
                                if (membershipM && (membershipM.roleID == undefined || membershipM.roleID == null)) {
                                    options.push({ label: " No Access", value: "0" });
                                }
                                return (
                                    <div className="formRow">
                                        <Dropdown
                                            name={c.id.toString()}
                                            label={c.userName}
                                            value={
                                                membershipM
                                                    ? membershipM.roleID == undefined
                                                        ? ""
                                                        : membershipM.roleID.toString()
                                                    : "0"
                                            }
                                            returnFunc={updateValue}
                                            Valid={
                                                membershipM &&
                                                (membershipM.roleID == undefined || membershipM.roleID == null)
                                                    ? false
                                                    : true
                                            }
                                            options={options.concat(
                                                mailboxRoles.map(items => {
                                                    return { label: items.name, value: items.id.toString() };
                                                }),
                                            )}
                                        ></Dropdown>
                                    </div>
                                );
                            })}
                    </div>
                )}
            </div>
        </>
    );
}
export default Memberships;
